<template>
  <div class="molecule-dashboard__container">
    <div class="title-progress-bar__container" :class="bgHeaderClass">
      <div v-if="isLoading" class="progress2 progress-moved">
        <div class="progress-bar2"></div>
      </div>
    </div>
    <header :class="bgHeaderClass">
      <div
        class="body__container justify-content-between align-items-center w-100"
        :class="classHeaderLayout"
      >
        <header
          v-if="title"
          class="d-flex justify-content-center justify-content-md-start align-items-center"
        >
          <feather-icon
            v-if="icon"
            :icon="icon"
            size="18"
            :stroke="primaryColor"
            style="margin-right: 5px"
          />
          <label
            class="mb-0"
            :class="[
              isBgHeader ? 'text-title-primary' : 'text-title',
              { 'text-ellipsis': isTitleEllipsis },
            ]"
            >{{ title.toUpperCase() }}</label
          >
          <b-badge
            v-if="badgeText"
            pill
            :variant="badgeVariant"
            class="badge-title text-size-12"
          >
            {{ badgeText }}
          </b-badge>
        </header>
        <slot name="header"></slot>
      </div>
    </header>

    <div
      class="pt-0"
      :class="[bodyContainerClass, { body__container: isHasBodyPadding }]"
    >
      <div class="d-flex justify-content-center align-items-center">
        <slot name="body"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { BBadge } from "bootstrap-vue"
import AtomProgressBar from "@/components/atoms/graphs/AtomProgressBar.vue"

export default {
  name: "MoleculeDashboardContainer",
  components: { AtomProgressBar, BBadge },
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
    badgeText: {
      type: String,
      required: false,
      default: "",
    },
    badgeVariant: {
      type: String,
      required: false,
      default: "",
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: true,
    },
    icon: {
      type: String,
      required: false,
      default: "",
    },
    isBgHeader: {
      type: Boolean,
      required: false,
      default: false,
    },
    isHasBodyPadding: {
      type: Boolean,
      required: false,
      default: true,
    },
    classHeaderLayout: {
      type: String,
      required: false,
      default: "d-md-flex",
    },
    bodyContainerClass: {
      type: String,
      required: false,
      default: "",
    },
    isTitleEllipsis: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      primaryColor: "#7367F0",
    }
  },
  computed: {
    bgHeaderClass() {
      return this.isBgHeader ? "bg__header" : ""
    },
  },
}
</script>

<style lang="scss" scoped>
.molecule-dashboard__container {
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
}

.bg__header {
  background-color: #f1f0fe;
}

.text-title-primary {
  color: #7367f0;
  font-weight: 500;
  font-size: 12px;
}

.text-title {
  color: 5e5873;
  font-weight: 600;
  font-size: 14px;
}

.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.title-progress-bar__container {
  width: 100%;
  height: 3px;
  padding: 0 10px;
  position: relative;
}

.progress2 {
  border-radius: 30px;
  background-color: #eeedfd;
}

.progress-bar2 {
  height: 3px;
  border-radius: 30px;
  transition: 0.4s linear;
  transition-property: width, background-color;
}

.progress-moved .progress-bar2 {
  animation: progress 2s infinite;
}

@keyframes progress {
  0% {
    width: 0%;
    background: #7367f0;
  }

  100% {
    width: 100%;
    background: #7367f0;
  }
}

.body__container {
  padding: 12px 14px 15px 14px;
}

.badge-title {
  margin-left: 10px;
}
</style>
